export * from "-!../../../node_modules/extract-text-webpack-plugin/dist/loader.js??ref--9-0!../../../node_modules/vue-style-loader/index.js!../../../node_modules/css-loader/index.js??ref--9-2!../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../node_modules/sass-loader/lib/loader.js??ref--9-3!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Dashboard.vue?vue&type=style&index=0&id=b1141f10&prod&lang=scss&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/components/dashboard/Dashboard.vue?vue&type=style&index=0&id=b1141f10&prod&lang=scss&scoped=true
// module id = Xafz
// module chunks = 41